const config = {
    title: 'RESILENT HER',
    description: 'A collection of 9880 iron-willed females with one heart and one fight. The future is female.',
    contractAddress: '0x777e18062121E0792AF99D3606b9D56EE0E59f0c',
    maxMintAmount: 1,
    presaleMaxMintAmount: 2,
    price: 0.01
  }
  
  export { config }
  